export function formatCurrency(value, currency = 'USD', options = {}) {
    if (value == null) {
        return null;
    }
    return value.toLocaleString(undefined, {
        style: 'currency',
        currency,
        ...options,
    });
}
//# sourceMappingURL=format-currency.js.map